module.exports = __webpack_public_path__ + "static/media/catalog-bg.6818cfe7.jpg";